export default __webpack_public_path__ + "static/media/mons5.9052da7c.jpg";